import { Snippet } from 'api/clients/SnippetClient'
import { ADD_SNIPPET, DELETE_SNIPPET, SET_SNIPPETS, SHOW_SNIPPETS_RAIL } from 'redux/constants'

export const deleteSnippet = (id: number) => {
  return { type: DELETE_SNIPPET, payload: { id } }
}

export const addSnippet = (snippet: Snippet) => {
  return { type: ADD_SNIPPET, payload: { snippet } }
}

export const setSnippets = (snippets: Snippet[]) => {
  return { type: SET_SNIPPETS, payload: { snippets } }
}

export const showSnippetsRail = (show: boolean) => ({ type: SHOW_SNIPPETS_RAIL, payload: { show } })
